<template>
	<section class="s_main">
		<div class="s_container">
			<article class="s_left">
				<div v-html="config.cfgDesc"></div>
			</article>

		</div>
        <div style="width: 100%;text-align: center; margin: 30px auto;">
						<button @click="tosub" style="cursor: pointer;border:0px;width: 200px;height: 35px;background-color:#141651; color:#ffffff;font-size:16px;margin-right: 50px;">Submit</button>

						<button @click="tostatus" style="cursor: pointer;border:0px;width: 200px;height: 35px;background-color:#141651; color:#ffffff;font-size:16px;">Abstract &nbsp;&nbsp; Status</button>
        </div>
	</section>

</template>
<script>
	export default {
		data() {
				return {
					cid: 0,
					end_dt: "",
					config: {
						cfgDesc: "Loading..."
					},
					language: 'en'
				}
			},
			props: {},
			methods: {
				getEnDateStr(timestamp) {
					let date = new Date(timestamp);
					let monthArray = new Array("January", "February", "March", "April", "May", "June", "July", "August",
						"September", "October", "November", "December");
					let month = date.getMonth();
					let day = date.getDate();
					if(day.toString().length == 1) {
						day = "0" + day.toString();
					}
					let dtstr = monthArray[month] + " " + day + ", " +
						date.getFullYear();
					return dtstr;
				}
			},
			computed: {},
			mounted() {
				this.cid = 2006;
				this.language = this.$route.params.language;
				//获取会议对应的正文投稿配置
				this.postHttp('/medapp/api/paper/getconfig', {
					cid: this.cid,
					language: this.language
				}).then((result) => {
					let data = '';
					if(result.data.config != null) {
						this.config = result.data.config;
//						this.end_dt = this.getEnDateStr(this.config.cfgEndDt);
						return;
					}

				})
			},
    methods:{
		    tosub(){
		    	  let userStore = JSON.parse(localStorage.getItem('user'));
		    	   localStorage.setItem('paperId',0)
		      if(userStore == undefined || userStore == null){
		      	 sessionStorage.setItem('back_url','/home_en/2006/submit/Abstract')
		        this.$router.push('/home_en/2006/detail/login');
		        return;
		      }

		        this.$router.push('/home_en/2006/submit/Abstract');
       },
       tostatus(){
       	    let userStore = JSON.parse(localStorage.getItem('user'));
		      if(userStore == undefined || userStore == null){
            sessionStorage.setItem('back_url','/home_en/2006/abstract/status')
		        this.$router.push('/home_en/2006/detail/login');
		        return;
		      }
		        this.$router.push('/home_en/2006/abstract/status');
       }
    }
	}
</script>
<style scoped>
	.s_main {
		color: #000000;
		width: 1200px;
		font-size: 16px;
		border: 1px solid #eeeeee;
		margin: 90px auto -40px;
		padding: 5px;
		min-height: 20px;
	}

	.s_container {
		width: 100%;
		margin: auto;
		overflow: hidden;
	}

	aside.s_right {
		float: right;
		width: 25%;
		margin-top: 10px;
	}

	article.s_left {
		margin: 10px;
		border: 1px solid #eeeeee;
		width: 98%;
		padding: 10px;
    text-align: justify;
	}

	.s_box {
		padding: 15px;
		background: #2B2D62;
		color: #FFFFFF;
		font-size: 18px;
		margin-bottom: 6px;
		text-align: center;
		font-weight: bold;
	}

	.s_box button {
		height: 50px;
		width: 100%;
		background: #FFFFFF;
		border: 0;
		margin: 18px auto 18px;
		font-size: 18px;
		color: #2B2D62;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// overview.vue?6bc4cdda